import { render } from "./Profile.vue?vue&type=template&id=98046592"
import script from "./Profile.vue?vue&type=script&lang=js"
export * from "./Profile.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/settings/Profile.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "98046592"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('98046592', __exports__)) {
    api.reload('98046592', __exports__)
  }
  
  module.hot.accept("./Profile.vue?vue&type=template&id=98046592", () => {
    api.rerender('98046592', render)
  })

}


export default __exports__